import { AutoAwesome, Business, Edit, Fingerprint, RefreshOutlined, RequestQuote, Search } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";

interface AnalysisActionsProps {
    onUpdateStatus?: () => void;
    onRevertAnalysis?: () => void;
    showRevertAnalysis?: boolean;
    disableRevertAnalysis?: boolean;
	onResendAnalysis?: () => void;
	showResendAnalysis?: boolean;
	onViewBiometry?: () => void;
	showViewBiometry?: boolean;
    onViewCreditDetails?: () => void;
    showViewCreditDetails?: boolean;

	onGenerateSetupFee?: () => void;
	showGenerateSetupFee?: boolean;

	onConvertToPj?: () => void;
	showConvertToPj?: boolean;
}

export const AnalysisActions: React.FC<AnalysisActionsProps> = ({
    onUpdateStatus,
    onRevertAnalysis,
    showRevertAnalysis,
    disableRevertAnalysis,
	onResendAnalysis,
	showResendAnalysis,
	onViewBiometry,
	showViewBiometry,
    onViewCreditDetails,
    showViewCreditDetails,
    onGenerateSetupFee,
    showGenerateSetupFee,
	onConvertToPj,
	showConvertToPj,
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const showUpdateStatusItem = Boolean(onUpdateStatus);
    const showRevertAnalysisItem = Boolean(showRevertAnalysis && onRevertAnalysis);
    const showResendAnalysisItem = Boolean(showResendAnalysis && onResendAnalysis);
    const showViewBiometryItem = Boolean(showViewBiometry && onViewBiometry);
    const showCreditDetailsItem = Boolean(showViewCreditDetails && onViewCreditDetails);
    const showGenerateSetupFeeItem = Boolean(showGenerateSetupFee && onGenerateSetupFee);
    const showConvertToPjItem = Boolean(showConvertToPj && onConvertToPj);
    const hasExtraGroup = showResendAnalysisItem || showViewBiometryItem || showCreditDetailsItem || showGenerateSetupFeeItem || showConvertToPjItem;

    return (
        <>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {showUpdateStatusItem && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onUpdateStatus?.();
                        }}
                    >
                        <ListItemIcon>
                            <Edit fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Alterar Status</ListItemText>
                    </MenuItem>
                )}

                {showRevertAnalysisItem && (
					<MenuItem
						disabled={Boolean(disableRevertAnalysis)}
						onClick={() => {
							handleClose();
                            onRevertAnalysis?.();
						}}
					>
						<ListItemIcon>
							<RefreshOutlined fontSize="small" />
						</ListItemIcon>
						<ListItemText>Reverter Análise</ListItemText>
					</MenuItem>
				)}

                {hasExtraGroup && <Divider sx={{ my: 0.5 }} />}

                {showCreditDetailsItem && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onViewCreditDetails?.();
                        }}
                    >
                        <ListItemIcon>
                            <Search fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Detalhes do Crédito</ListItemText>
                    </MenuItem>
                )}

                {showResendAnalysisItem && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onResendAnalysis?.();
                        }}
                    >
                        <ListItemIcon>
                            <AutoAwesome fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Reenviar Análise Crédito</ListItemText>
                    </MenuItem>
                )}

                {showViewBiometryItem && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onViewBiometry?.();
                        }}
                    >
                        <ListItemIcon>
                            <Fingerprint fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Visualizar Biometria</ListItemText>
                    </MenuItem>
                )}

				{showConvertToPjItem && (
					<MenuItem
						onClick={() => {
							handleClose();
							onConvertToPj?.();
						}}
					>
						<ListItemIcon>
							<Business fontSize="small" />
						</ListItemIcon>
						<ListItemText>Converter análise para PJ</ListItemText>
					</MenuItem>
				)}

                {showGenerateSetupFeeItem && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            onGenerateSetupFee?.();
                        }}
                    >
                        <ListItemIcon>
                            <RequestQuote fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Gerar taxa de setup</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};
